import { Navigate, useLocation } from 'react-router-dom';
import { pathForLegacyView, tokenFromLocation } from '../../../Utils/legacyLinks';
import { routes } from '../../../Utils/routes';

/**
 * Catches a link written by the JavaScript application and sends it to the
 * route that answers it now.
 *
 * `replace` throughout: the old URL should not sit in the history where the
 * back button will bounce a parent straight back onto it.
 */

/** `/pay/#token` and `/pay/?t=token` become `/pay/:token`. */
export function LegacyPaymentRequestLink() {
  const location = useLocation();
  const token = tokenFromLocation(location.hash, location.search);
  if (!token) return <Navigate to={routes.home} replace />;
  return <Navigate to={`/pay/${encodeURIComponent(token)}`} replace />;
}

/** `/intake/#token` and `/intake/?t=token` become `/intake/:token`. */
export function LegacyIntakeFormLink() {
  const location = useLocation();
  const token = tokenFromLocation(location.hash, location.search);
  if (!token) return <Navigate to={routes.home} replace />;
  return <Navigate to={`/intake/${encodeURIComponent(token)}`} replace />;
}

/**
 * A bookmark of the old hash-routed app, such as `/user/#payments`. With no
 * recognised view it simply renders the overview, which is what `/user` does
 * anyway.
 */
export function LegacyAppView({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const path = pathForLegacyView(location.hash);
  if (path && path !== location.pathname) return <Navigate to={path} replace />;
  return <>{children}</>;
}
